<template>
    <div>
      <h1>Register Users</h1>
      <p>Manage user registrations here.</p>
    </div>
  </template>
  
  <script>
  export default {
    name: 'RegisterUsersIndex',
  };
  </script>
  
  <style scoped>
  /* Add your styles here */
  </style>